import React from 'react';
import UberHealthIcon from '../../../assets/svgs/uberHealth.svg';
import styles from './index.module.css';

export const UberHealthTag = ({ label = 'Uber Health', className }) => {
  return (
    <span className={`${styles.uberHealthTag} ${className || ''}`.trim()}>
      <img src={UberHealthIcon} alt="Uber Health" className={styles.uberHealthIcon} />
      {label}
    </span>
  );
};

